"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.mapDispatchToActions = void 0;

var _mapDispatchToActions = _interopRequireDefault(require("./mapDispatchToActions"));

exports.mapDispatchToActions = _mapDispatchToActions["default"];